import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Pipe({
  name: "s3Img",
})
export class S3ImagePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  async transform(src: string): Promise<SafeUrl> {
    const headers = new HttpHeaders({
      "X-access-token": localStorage.getItem("acc_tok"),
    });

    // try {
    return await this.http.get(src + "&type=link", { headers }).toPromise();
  }
}
